var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ActivityComponent',{attrs:{"id-types":_vm.id_types,"headers":_vm.headers,"user-id":_vm.profileId,"permission":"users.activities"}})}
var staticRenderFns = []

export { render, staticRenderFns }